import Asset from './Asset';
import IAsset from './IAsset'

export default abstract class UserAsset extends Asset implements IAsset {
}



// WEBPACK FOOTER //
// src/opt/atlassian/pipelines/agent/build/src/api/model/UserAsset.ts